// import { blue } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette : {
        primary : {
            main : "#0C4A6F"//"#0f80aa"
        },
        background: {
            default: "#ffffff"  // Establece el color de fondo del body a blanco
        }
    },
    // spacing: 5,  // Valor base del espaciado (opcional si deseas usar el valor predeterminado)
    overrides: {
        MuiTextField: {
          root: {
            backgroundColor: '#fff',
          },
        },
        MuiIconButton: {
          root: {
            padding: 0, // Cambia el padding globalmente para todos los IconButton
          },
          edgeEnd: {
            marginRight: 5,
          }
        },
        MuiOutlinedInput: {
          adornedEnd: {
            paddingRight: 5, // Cambia el padding-right a 5px en lugar de 14px
          },
        },
        MuiTableCell: {
          root: {
            padding: 10, // Cambia el padding-right a 5px en
          }
        },
        // MuiOutlinedInput: {
        //   root: {
        //     '& fieldset': {
        //       borderColor: 'rgba(0,0,0,0.23)', // Restablecer el color predeterminado si es necesario
        //     },
        //     '&:hover fieldset': {
        //       borderColor: 'rgba(0,0,0,0.23)', // Restablecer para el estado hover si es necesario
        //     },
        //     '&$focused fieldset': {
        //       borderColor: 'blue', // Cambia si deseas un color diferente cuando está enfocado
        //     },
        //   },
        //   notchedOutline: {
        //     borderColor: 'rgba(0,0,0,0.23)',
        //   },
        // },
      },

})

export default theme;